<template>
  <div class="tw-flex">
    <amex-icon class="tw-h-full" v-show="isAmex === true" />
    <diners-club-icon class="tw-h-full" v-show="isDiners === true" />
    <discover-icon class="tw-h-full" v-show="isDiscover === true" />
    <jcb-icon class="tw-h-full" v-show="isJcb === true" />
    <mastercard-icon class="tw-h-full" v-show="isMastercard === true" />
    <union-pay-icon class="tw-h-full" v-show="isUnionPay === true" />
    <visa-icon class="tw-h-full" v-show="isVisa === true" />
  </div>
</template>
<script>
import { AmexIcon, DinersClubIcon, DiscoverIcon, JcbIcon, MastercardIcon, UnionPayIcon, VisaIcon } from "@/assets/svgs";

export default {
  name: "CreditCardIcon",
  components: {
    AmexIcon,
    DinersClubIcon,
    DiscoverIcon,
    JcbIcon,
    MastercardIcon,
    UnionPayIcon,
    VisaIcon,
  },
  props: {
    name: { type: String, required: true, default: "" },
  },
  computed: {
    isAmex() {
      return this.name.toLowerCase() === "amex" || this.name.toLowerCase() === "american express";
    },
    isDiners() {
      return this.name.toLowerCase() === "diners" || this.name.toLowerCase() === "diners club";
    },
    isDiscover() {
      return this.name.toLowerCase() === "discover";
    },
    isJcb() {
      return this.name.toLowerCase() === "jcb";
    },
    isMastercard() {
      return this.name.toLowerCase() === "mastercard" || this.name.toLowerCase() === "master card";
    },
    isUnionPay() {
      return this.name.toLowerCase() === "unionpay";
    },
    isVisa() {
      return this.name.toLowerCase() === "visa";
    },
  },
};
</script>
